<script>
  import FormBase from '../../../components/FormBase';

  export default {
    name: 'FormPersona',
    extends: FormBase,
    methods: {
      getFormModel () {
        const formModel =Object.assign({}, this.formModel);
        if (this.id) {
          formModel.idImportador = this.id;
        }
        return formModel;
      },
      getSavePromise(formModel) {
        return this.id
          ? this.$http.post(
            this.updateUrl,
            formModel,
          )
          : this.$http.post(
            this.createUrl,
            formModel,
          );
      },
      onFormSaved(id) {
        this.$router.push('/importador');
      },
  },
  computed: {
      puedeEditar () {
        return true;
      },
      puedeEliminar () {
        return true;
      },
      createUrl() {
        return `${process.env.VUE_APP_ROOT_API}${this.baseUrl}/crear`;
      },
      updateUrl() {
        return `${process.env.VUE_APP_ROOT_API}${this.baseUrl}/actualizar`;
      },
    },
  };
</script>

<style scoped>

</style>
